import { render } from "./CS_sayhi.vue?vue&type=template&id=ec59d9c4&scoped=true"
import script from "./CS_sayhi.vue?vue&type=script&lang=js"
export * from "./CS_sayhi.vue?vue&type=script&lang=js"

import "./CS_sayhi.vue?vue&type=style&index=0&id=ec59d9c4&scoped=true&lang=css"
import "./CS_sayhi.vue?vue&type=style&index=1&id=ec59d9c4&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec59d9c4"]])

export default __exports__